<script lang="ts">
	export let url: string
	export let autoplay = false
	export let fit = true

	let loading = autoplay
	let allowPlay = true

	function player(node: HTMLElement) {
		let loaderTimer: number | undefined
		let videoTimer: number | undefined

		const video = node.querySelector('video') as HTMLVideoElement

		function loadVideo() {
			const sources = video.querySelectorAll('source')
			sources.forEach((source) => {
				source.src = source.dataset.src as string
			})
			video.load()
		}

		video.onwaiting = () => (loading = true)
		video.onplaying = () => (loading = false)

		video.oncanplaythrough = async () => {
			if (allowPlay) {
				video.removeAttribute('hidden')
				await video.play()
			}
		}

		if (autoplay) {
			loadVideo()
		}

		node.onmouseover = async () => {
			if (autoplay) {
				return
			}
			allowPlay = true
			if (!video.currentSrc) {
				loaderTimer = window.setTimeout(() => (loading = true), 100)
				videoTimer = window.setTimeout(loadVideo, 250)
			} else {
				video.removeAttribute('hidden')
				await video.play()
			}
		}

		node.onmouseleave = () => {
			if (autoplay) {
				return
			}
			window.clearTimeout(loaderTimer)
			window.clearTimeout(videoTimer)
			allowPlay = false
			loading = false
			video.pause()
			video.setAttribute('hidden', '')
		}

		return {
			destroy() {
				window.clearTimeout(loaderTimer)
				window.clearTimeout(videoTimer)
			},
		}
	}
</script>

<div
	class="relative w-full h-full aspect-square md:max-w-video rounded-sm overflow-hidden flex items-center"
	use:player
>
	{#if loading}
		<div
			class="absolute h-full w-full flex justify-center items-center pointer-events-none"
		>
			<div
				class="animate-spin w-12 h-12 rounded-full border-green-500 border-solid border-4 border-b-transparent"
			/>
		</div>
	{/if}
	<video
		class="absolute w-full h-full md:max-w-video"
		class:object-contain={!fit}
		class:object-cover={fit}
		preload="none"
		playsinline
		muted
		loop
		hidden
	>
		<source data-src="{url}/preview.webm" type="video/webm" />
		<source data-src="{url}/preview.mp4" type="video/mp4" />
	</video>
	<img
		class="w-full h-full pointer-events-none"
		class:object-contain={!fit}
		class:object-cover={fit}
		src="{url}/poster.png"
		loading="lazy"
		alt=""
	/>
</div>
